import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "programs--sprite",
  "use": "programs--sprite-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"programs--sprite\">\n<path d=\"M13 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V5L13 0ZM4 4H9V6H4V4ZM14 14H4V12H14V14ZM14 10H4V8H14V10ZM12 6V2L16 6H12Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol